module.exports = __webpack_public_path__ + "img/CommunityChecked.b2333cd9.svg";